import { useState, useEffect, useCallback } from 'react';

export const useBrowserNotifications = () => {
    const [permission, setPermission] = useState('default');
    const [isSupported, setIsSupported] = useState(false);

    useEffect(() => {
        // Check if browser notifications are supported
        if ('Notification' in window) {
            setIsSupported(true);
            setPermission(Notification.permission);
        }
    }, []);

    const requestPermission = useCallback(async () => {
        if (!isSupported) return false;

        try {
            const result = await Notification.requestPermission();
            setPermission(result);
            return result === 'granted';
        } catch (error) {
            console.error('Failed to request notification permission:', error);
            return false;
        }
    }, [isSupported]);

    const showNotification = useCallback((title, options = {}) => {
        if (!isSupported || permission !== 'granted') {
            return null;
        }

        try {
            const notification = new Notification(title, {
                icon: '/favicon.ico',
                badge: '/favicon.ico',
                ...options
            });

            // Handle click
            notification.onclick = () => {
                window.focus();
                if (options.link) {
                    window.location.href = options.link;
                }
                notification.close();
            };

            // Auto-close after 5 seconds
            setTimeout(() => notification.close(), 5000);

            return notification;
        } catch (error) {
            console.error('Failed to show notification:', error);
            return null;
        }
    }, [isSupported, permission]);

    return {
        isSupported,
        permission,
        requestPermission,
        showNotification
    };
};

export default useBrowserNotifications;
